import React from 'react';

import RemoteMediaDisabled from '../RemoteMediaDisabled';

const message = { id: 'const.audioVideoDisabled', defaultMessage: '** Audio & Video Disabled' };

const RemoteAudioVideoDisabled = () => (
  <RemoteMediaDisabled
    iconName="audio-video-disabled"
    message={ message }
  />
);

export default RemoteAudioVideoDisabled;
